import type { UserManager } from 'oidc-client-ts';
import { cognitoUserManager } from '@/config/authConfig';
import { AUTH_STATE, type AuthContextType } from '@/types';
import { createContext } from 'react';

const defaultAuthContext: AuthContextType<UserManager> = {
  state: AUTH_STATE.UNAUTHENTICATED,
  userManager: cognitoUserManager,
  userInfo: null,
  logout: async () => {
    console.warn('logout called outside AuthProvider');
  },
  setAuthenticated: () => {
    console.warn('setAuth called outside AuthProvider');
  },
  setUserInfo: () => {
    console.warn('setUserInfo called outside AuthProvider');
  },
};

export const AuthContext = createContext(defaultAuthContext);
